import type { Endomorphism, io } from '@code-expert/prelude';
import { string } from '@code-expert/prelude';

const baseUrl: io.IO<string> = () => `${window.location.protocol}//${window.location.host}`;

/**
 * Convert a path to a URL including protocol and hostname.
 */
export const pathToUrl: Endomorphism<string> = string.prepend(baseUrl());
